<template>
    <div class="settings-layout">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.settings || "Settings" }}</h2>
            </div>
        </div>
        <v-list dense>
            <inertia-link href="/backoffice/settings">
                <v-list-item link :class="[{'v-list-item--active' : $page.props.currentRouteName === 'backoffice.settings.index'}, , 'primary--text']">
                    <v-list-item-content>
                        <v-list-item-title>{{$page.props.lang.account || "Account"}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </inertia-link>
            <inertia-link href="/backoffice/settings/theme">
                <v-list-item link :class="[{'v-list-item--active' : $page.props.currentRouteName === 'backoffice.settings.theme'}, 'primary--text']">
                    <v-list-item-content>
                        <v-list-item-title>{{$page.props.lang.theme || "Theme"}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </inertia-link>
            <inertia-link href="/backoffice/settings/classes">
                <v-list-item link :class="[{'v-list-item--active' : $page.props.currentRouteName === 'backoffice.settings.classes'}, 'primary--text']">
                    <v-list-item-content>
                        <v-list-item-title>{{$page.props.lang.classes || "Classes"}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </inertia-link>
            <inertia-link v-if="$page.props.organization.features['customs']" href="/backoffice/settings/memberCustomFields">
                <v-list-item link :class="[{'v-list-item--active' : $page.props.currentRouteName === 'backoffice.settings.member_custom_fields'}, 'primary--text']">
                    <v-list-item-content>
                        <v-list-item-title>{{$page.props.lang.memberCustomFields || "Member Custom Fields"}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </inertia-link>
            <inertia-link v-if="$page.props.organization.features['portal']" href="/backoffice/settings/booking">
                <v-list-item link :class="[{'v-list-item--active' : $page.props.currentRouteName === 'backoffice.settings.booking'}, 'primary--text']">
                    <v-list-item-content>
                        <v-list-item-title>{{$page.props.lang.booking_settings || "Booking Settings"}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </inertia-link>
            <inertia-link href="/backoffice/settings/notifications">
                <v-list-item link :class="[{'v-list-item--active' : $page.props.currentRouteName === 'backoffice.settings.notifications'}, 'primary--text']">
                    <v-list-item-content>
                        <v-list-item-title>{{$page.props.lang.notifications || "Notifications"}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </inertia-link>
        </v-list>
        <div class="slot-card">

            <slot></slot>

        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
